import { cn } from "@/util/cn";

export default function CreditCardIcon({ className }: { className?: string }) {
  return (
    <svg
      width="120"
      height="76"
      viewBox="0 0 120 76"
      fill="none"
      className={cn(
        "ml-auto opacity-95 group-hover:opacity-100 transition-all duration-300 flex-shrink-0 shadow-lg hover:shadow-2xl hover:-translate-y-0.5 transform",
        className
      )}
    >
      <defs>
        <linearGradient id="card-bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#1e2230" />
          <stop offset="60%" stopColor="#131620" />
          <stop offset="100%" stopColor="#090a0f" />
        </linearGradient>
        <linearGradient id="chip-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ffe699" />
          <stop offset="50%" stopColor="#d4af37" />
          <stop offset="100%" stopColor="#9a7b1c" />
        </linearGradient>
        <linearGradient id="mc-red" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ff4646" />
          <stop offset="100%" stopColor="#c31313" />
        </linearGradient>
        <linearGradient id="mc-orange" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ffab35" />
          <stop offset="100%" stopColor="#df6c1f" />
        </linearGradient>
        <linearGradient id="glass-reflect" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.12" />
          <stop offset="30%" stopColor="#ffffff" stopOpacity="0.05" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0.0" />
        </linearGradient>
      </defs>

      {/* Card Body */}
      <rect width="120" height="76" rx="8" fill="url(#card-bg)" stroke="rgba(255, 255, 255, 0.12)" strokeWidth="1" />

      {/* Glass Reflection */}
      <path d="M 0,0 L 120,0 L 120,24 L 0,48 Z" fill="url(#glass-reflect)" />

      {/* Brand Accent Glow */}
      <circle cx="10" cy="10" r="30" fill="#34a853" opacity="0.02" filter="blur(10px)" />
      <circle cx="110" cy="66" r="25" fill="#1a73e8" opacity="0.02" filter="blur(8px)" />

      {/* Metallic Chip */}
      <rect x="12" y="16" width="18" height="13" rx="2.5" fill="url(#chip-grad)" />
      <rect x="15" y="16" width="0.5" height="13" fill="#6f5509" opacity="0.25" />
      <rect x="26" y="16" width="0.5" height="13" fill="#6f5509" opacity="0.25" />
      <rect x="12" y="20" width="18" height="0.5" fill="#6f5509" opacity="0.25" />
      <rect x="12" y="25" width="18" height="0.5" fill="#6f5509" opacity="0.25" />
      <rect x="15" y="20" width="11" height="5" rx="0.75" fill="none" stroke="#6f5509" strokeWidth="0.5" opacity="0.25" />

      {/* Contactless Icon */}
      <g opacity="0.6">
        <path d="M 35,17 C 35.8,18.8 35.8,20.2 35,22" stroke="white" strokeWidth="0.8" strokeLinecap="round" fill="none" />
        <path d="M 37.5,15 C 38.8,17.2 38.8,19.8 37.5,22" stroke="white" strokeWidth="0.8" strokeLinecap="round" fill="none" />
        <path d="M 40,13 C 41.8,15.8 41.8,19.2 40,22" stroke="white" strokeWidth="0.8" strokeLinecap="round" fill="none" />
      </g>

      {/* Card Number (Embossed look) */}
      <text
        x="8"
        y="47"
        fill="#ffffff"
        fillOpacity="0.85"
        fontFamily="'Courier New', Courier, monospace"
        fontWeight="bold"
        fontSize="8"
        letterSpacing="1"
      >
        •••• •••• •••• 4242
      </text>

      {/* Card Holder Name */}
      <text
        x="8"
        y="63"
        fill="#ffffff"
        fillOpacity="0.45"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontWeight="600"
        fontSize="5"
        letterSpacing="0.5"
      >
        VALUED CUSTOMER
      </text>

      {/* Expiry Date */}
      <text
        x="68"
        y="63"
        fill="#ffffff"
        fillOpacity="0.45"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontWeight="600"
        fontSize="5"
        letterSpacing="0.5"
      >
        12/29
      </text>

      {/* Overlapping Brand Logo (Mastercard look) */}
      <g transform="translate(0, 2)">
        <circle cx="100" cy="58" r="6" fill="url(#mc-red)" />
        <circle cx="106" cy="58" r="6" fill="url(#mc-orange)" fillOpacity="0.9" style={{ mixBlendMode: "screen" }} />
      </g>
    </svg>
  );
}
